import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.black1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.black5};
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  z-index: 10;
`;

export const ProgressHeader = styled.button<{ $isExpanded?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: none;
  border-radius: 0 0 16px 16px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    transition: transform 0.2s ease;
    transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  }
`;

export const ProgressBarWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProgressLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProgressLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

export const ProgressValue = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.green6};
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.black5};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.green6} 0%,
    ${({ theme }) => theme.colors.green5} 100%
  );
  border-radius: 3px;
  transition: width 0.5s ease;
`;

export const TopicsWrapper = styled.div<{ $isExpanded?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: ${({ $isExpanded }) => ($isExpanded ? '0 16px 16px' : '0')};
  max-height: ${({ $isExpanded }) => ($isExpanded ? '300px' : '0')};
  overflow-y: auto;
  transition: all 0.3s ease;
`;

export const TopicItem = styled.div<{ $status: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  transition: all 0.2s ease;

  background-color: ${({ theme, $status }) => {
    switch ($status) {
      case 'verified':
        return theme.colors.green1;
      case 'in_progress':
        return `${theme.colors.royal}15`;
      case 'needs_work':
        return theme.colors.orange1;
      case 'skipped':
        return theme.colors.black6;
      default:
        return theme.colors.black1;
    }
  }};

  color: ${({ theme, $status }) => {
    switch ($status) {
      case 'verified':
        return theme.colors.green6;
      case 'in_progress':
        return theme.colors.royal;
      case 'needs_work':
        return theme.colors.orange6;
      case 'skipped':
        return theme.colors.black4;
      default:
        return theme.colors.black9;
    }
  }};
`;

export const TopicName = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TopicScore = styled.span`
  font-weight: 600;
  min-width: 30px;
  text-align: right;
  font-size: 12px;
`;
